module.exports = __webpack_public_path__ + "static/media/video-advmindfulness-observer-perspective-es.b4fc68aa.vtt";